import { array, boolean, mixed, object, string } from "yup";
import { PleaseDescribeYourProblemErrorText, PleaseSelectReplacementReasonErrorText } from "constants/text";
import { ReplacementFile } from "features/reducers/replacementOrder/cart";

export const HasItemBeenReplacedBeforeErrorText = "Please tell us if this item has been replaced before.";
export const HasItemBeenReplacedBeforeLabel = "Has this item been replaced before?";
export const PleaseAttachFileErrorText = "Please attach at least one file.";
export const PleaseAddComment = "Please add comment.";

export const schema = object({
	replacementReason: string().nullable().required(PleaseSelectReplacementReasonErrorText),
	replacementProblem: string().nullable().required(PleaseDescribeYourProblemErrorText),
	originalHasAnotherReplacementOrder: boolean().required(),
	qualityCheckFlag: boolean()
		.nullable()
		.when("originalHasAnotherReplacementOrder", {
			is: true,
			then: (s) => s.typeError(HasItemBeenReplacedBeforeErrorText).required(HasItemBeenReplacedBeforeErrorText),
			otherwise: (s) => s.nullable()
		}),
	fileUploads: array().of(mixed<ReplacementFile>().required()).nullable(),
	comment: string().when("qualityCheckFlag", {
		is: true,
		then: (s) => s.required(PleaseAddComment),
		otherwise: (s) => s.nullable()
	})
});

export type FormSchema = {
	replacementReason: string | null;
	replacementProblem: string | null;
	originalHasAnotherReplacementOrder: boolean;
	qualityCheckFlag: boolean | null | undefined;
	fileUploads: ReplacementFile[] | null | undefined;
	comment: string | null | undefined;
};
